import { render, staticRenderFns } from "./SpaceEditForm.vue?vue&type=template&id=0e2e51eb&scoped=true"
import script from "./SpaceEditForm.vue?vue&type=script&lang=js"
export * from "./SpaceEditForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e2e51eb",
  null
  
)

export default component.exports